import React, { useState } from 'react';
import ListarGrupos from './ListarGrupos';
import RegistrarGrupos from './RegistrarGrupos';

const Grupos = () => {
  const [refresh, setRefresh] = useState(false); 

  const actualizarGrupos = () => {
    setRefresh(prev => !prev);  // Cambia el estado para forzar la actualización
  };

  return (
    <div>
      <RegistrarGrupos actualizarGrupos={actualizarGrupos} />
      <ListarGrupos refresh={refresh} />
    </div>
  )
}

export default Grupos
